<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import {request} from './untils/request'
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'App',
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      v: 0
    }
  },
  created () {
    // 主题
    this.getTheme ()
    let tag = this.GetQueryString('tag')
    if(tag==='3d32f4b0'){
      // this.getToken()
    } else {
      // 获取用户信息
      if (this.$cookies.get('accessToken')) {
        this.getUser()
      }
    }
  },
  methods:{
    // 获取主题
    getTheme () {
      let themeLink = document.querySelector('link[name="theme"]')
      request('get', '/nlc-web/api/theme').then(res => {
        console.log('主题', res)
        themeLink.setAttribute("href", this.baseUrl+res.data.style);
        if (res.data.themeColor!=='default') {
          document.getElementById('html').style.filter = 'grayscale(100%)'
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 获取用户信息
    getUser () {
      request('post', '/nlc-api/api/nlc/userInfo', {}).then(res => {
        console.log('用户信息', res)
        this.$store.commit('changeUserInfo', res.data.user)
        this.$store.commit('changeUid', res.data.user.uid)
        this.$store.commit('changeRcardId', res.data.rcardId)
        if(res.data.ecardUserInfo){
          this.$store.commit('changeBalance', res.data.ecardUserInfo.charge)
        }
        this.$store.commit('changeIdno', res.data.user.idno)
      })
    },
    // 获取地址栏参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
    // 获取token
    getToken(){
      axios({
        url:'http://m.nlc.cn/nlc-api/api/nlc/getAccesstoken?uid=8888888500966948&pwd=62097102',
        method:'get',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
      }).then(res=>{
        Cookies.set('accessToken', res.data.data.accessToken)
        Cookies.set('accessToken', res.data.data.accessToken,{domain: 'sso1.nlc.cn'})
        Cookies.set('accessToken', res.data.data.accessToken,{domain: '.sso1.nlc.cn'})
        Cookies.set('accessToken', res.data.data.accessToken,{domain: 'm.nlc.cn'})
        Cookies.set('accessToken', res.data.data.accessToken,{domain: '.m.nlc.cn'})
        Cookies.set('accessToken', res.data.data.accessToken,{domain: 'nlc.cn'})
        Cookies.set('accessToken', res.data.data.accessToken,{domain: '.nlc.cn'})
        this.getUser()
      })
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/App.vue